import React, { Component } from 'react';
import './../PersonRegist.css'
import Api from '../../../api/wxapi';




//消息
export default class MessageList extends Component {
  constructor(props) {
    super();
    this.state = {
      messages: []

    };

  }

  componentDidMount() {
    document.title = '消息'
    this.getMessages()
  }
  render() {
    let { messages } = this.state


    return (
      <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1,background: "#fff" }}>

        <div className='flex-column-container' style={{ flex: 1, }}>
          {messages.length<=0&& (<div><p>暂时没有收到消息</p></div>)} 
          {messages.map((item, index) => {

            return (<div className='flex-column-container' key={index} style={{paddingTop:5,paddingLeft:10,paddingRight:10,paddingBottom:5}}>
              <div className='flex-row-container' style={{height:80,flex:1 ,alignItems:'center' }} onClick={()=>this.gotodetail(item)}>
              <img src={ item.type=='suggestion'? require('../../../assets/caina.png'):require('../../../assets/baoxiu.png')} style={{width:50,height:50}}></img>
                <div className='flex-column-container' >
                 
                    <div className='flex-row-container' style={{marginLeft:10  }}> 
                    <p >{item.type=='suggestion'? '建议采纳通知':'故障报修提醒'}</p>
                    <p style={{position:'absolute',right:10}} >{item.create_time.split('T')[0]} </p> 
                    </div> 
                    <p className='dhp' style={{ marginLeft: 10 }}>{item.type=='suggestion'? '感谢您提供宝贵的使用建议,我们在“奖励”给您留有惊喜':'您有一条报修提醒,请查收!'}</p>
                </div>
             
              </div>

              <div style={{ height: 2, backgroundColor: '#F4F4F4', width: '100%', marginTop: 5 }}></div>

            </div>)

          })}

        </div>
      </div>
    )
  }
    

  gotodetail(item){
          if(item.type=='faultpost'){
            var path={
              pathname:'/person/message/MessageDetail',
              query:item, 
             }
           this.props.history.push(path)  
          }
  }

  getMessages(){
    Api.getMessages().then(res=>{

     if(res.data.code==0){

      let temp=[]
      if(res.data.data.feedbacks){
        res.data.data.feedbacks.map(item=>{
           item.type='suggestion'
           temp.push(item)
        })
      }

      if(res.data.data.faults){
        res.data.data.faults.map(item=>{
           item.type='faultpost'
           temp.push(item)
          
        })
      }
     this.setState({messages:temp})
     
     }

    })

  }



}



// WEBPACK FOOTER //
// ./src/views/person/message/MessageList.js